$('.cart-actions').each(function(_, element){
    var actions = $(element);
    var options = actions.find('.cart-actions-options');
    var toggle = actions.find('.toggle-options');
    var text = toggle.html();
    var title = toggle.attr('title');
    var toggleText = toggle.data('toggle-text');
    var toggleTitle = toggle.data('toggle-title');

	toggle.on('click', function(ev) {
		ev.preventDefault();

		if(options.hasClass('toggle-on')) {
			options.removeClass('toggle-on');
			toggle.html(text);
			toggle.attr('title', title);
		} else {
			options.addClass('toggle-on');
			toggle.html(toggleText);
			toggle.attr('title', toggleTitle);
		}

		$(document).trigger('layout-changed');
	});
});

$('.save-and-close').on('click', function(e) {
    e.preventDefault();
    $(e.currentTarget).closest('form.save-and-close').submit();
});

$('.cart-share a').on('click', function(e) {
    var requestUriPrefix = window && window.countryCode ? window.countryCode : '';
    var language = $(e.currentTarget).data('language');
	var requestUrl = requestUriPrefix + '/shop/'+language+'/cart/share-current-cart-ajax';

    $.get(requestUrl, function(result) {
        window.location.href = 'mailto:?subject=' + result.emailSubject + '&body=' + result.emailBody;
    });
	return false;
});

function closeCartActionsPanel() {
    $('.cart-actions-panel.toggle-on').each(function(_, element) {
        const $openPanel = $(element);
        $openPanel.trigger('panel-off');
   });
}

function displayDownloadStatusMessage(resultData) {
    if (!resultData) return;

    let messagesHtml = '';
    if (resultData.errorMessage) {
        messagesHtml += '<p class="downloadcenter-add">' + errorData.errorMessage + '</p>';
    }
    else if (resultData.multipleErrorMessages && resultData.multipleErrorMessages.length) {
        for (const errorMessage of resultData.multipleErrorMessages) {
            messagesHtml += '<p class="downloadcenter-add">' + errorMessage.message + '</p>';
        }
    }
    if (messagesHtml === '') return;

    const buttons = [];

    if(resultData.viewDownloadFolderUrl) {
        buttons.push({
            label: resultData.viewDownloadFolderButtonText ? resultData.viewDownloadFolderButtonText : 'View Download Folder',
            type: 'button',
            callback: () => {
                window.location.assign(resultData.viewDownloadFolderUrl);
            }
        });
    }

    buttons.push({
        label: resultData.closeButtonText ? resultData.closeButtonText : 'Close',
        type: 'button',
        callback: Belimo.Modal.close
    });

    closeCartActionsPanel();
    Belimo.Modal.open(messagesHtml, buttons);
}

(function() {
   var ui = {
      $actionGroup: $('.cart-action-group.download-folder'),
      $errorSpan: null,
      $buttons: $('.cart-action-group.download-folder .classification_type'),
      $actionUrl: $('.cart-action-group.download-folder #action-url')
   };
   var inputData = {
      actionUrl: ui.$actionUrl.val()
   };

   function extractErrorText(data) {
      if(data &&
         data.multipleErrorMessages &&
         data.multipleErrorMessages.length &&
         data.multipleErrorMessages.length > 0) {

         for(var i = 0; i < data.multipleErrorMessages.length; ++i) {
            if(data.multipleErrorMessages[i].message) {
               return data.multipleErrorMessages[i].message;
            }
         }
      }
      return '';
   }

   ui.$buttons.click(function(ev){
      if(ui.$errorSpan) ui.$errorSpan.text('');
      ui.$errorSpan = $(ev.currentTarget).prev('.error');

      var docType = $(ev.currentTarget).attr('id');
      if(!inputData.actionUrl || !docType) return;

      $.post(inputData.actionUrl, {
         documentType: docType
      })
         .done(function(data) {
            const errorText = extractErrorText(data);
            if(data.entries) {
                Belimo.Downloadfolder.update(data.entries);
                displayDownloadStatusMessage(data);
            } else if(errorText) {
                ui.$errorSpan.text(errorText);
            }
         })
         .fail(function(jqXHR) {
            if(jqXHR && jqXHR.responseText) {
               console.error(jqXHR.responseText);
            }
         });
   });
})();
